<template>
	<div class="no-order">
		<img src="../assets/images/user/no-order.png" />
		<div @click="goHome" class="go-home">去首页逛逛</div>
	</div>
</template>

<script>
	export default {
		name: 'NoOrder',
		data() {
			return {
	
			};
		},
		methods: {
			goHome(){
				this.$router.push({
					path: "/",
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.no-order{
		height: 356px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		img{
			width: 103px;
			height: 72px;
		}
		.go-home{
			margin-top: 30px;
			width: 90px;
			height: 24px;
			line-height: 24px;
			background: #FFFFFF;
			border: 1px solid #EEEEEE;
			border-radius: 5px;
			color: #333333;
			font-size: 13px;
			text-align: center;
			cursor: pointer;
		}
	}
</style>
